const COLORS = ['#E11D48', '#F59E0B', '#10B981', '#3B82F6', '#8B5CF6', '#FCD34D'];
const SEGMENTS = 8;
const ANGLE = 360 / SEGMENTS;

function slicePath(index) {
  const r = 19;
  const start = (index * ANGLE - 90) * (Math.PI / 180);
  const end = ((index + 1) * ANGLE - 90) * (Math.PI / 180);
  const x1 = r * Math.cos(start);
  const y1 = r * Math.sin(start);
  const x2 = r * Math.cos(end);
  const y2 = r * Math.sin(end);
  return `M 0 0 L ${x1.toFixed(2)} ${y1.toFixed(2)} A ${r} ${r} 0 0 1 ${x2.toFixed(2)} ${y2.toFixed(2)} Z`;
}

export default function MiniRouletteLogo({ size = 32, spin = true, className = '' }) {
  return (
    <span
      className={`inline-flex items-center justify-center relative ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <span className={spin ? 'roulette-logo-spin' : ''} style={{ width: size, height: size, display: 'inline-block' }}>
        <svg viewBox="-22 -22 44 44" width={size} height={size} style={{ display: 'block' }}>
          <circle r="20" fill="#1F1207" stroke="#FFD93D" strokeWidth="2.5" />
          {Array.from({ length: SEGMENTS }).map((_, i) => (
            <path key={i} d={slicePath(i)} fill={COLORS[i % COLORS.length]} stroke="#fff" strokeWidth="0.55" />
          ))}
          <circle r="5" fill="#0B0E14" stroke="#FFD93D" strokeWidth="1.2" />
        </svg>
      </span>
      <svg
        viewBox="0 0 12 14"
        width={Math.max(8, size * 0.32)}
        height={Math.max(10, size * 0.4)}
        style={{ position: 'absolute', top: -2, left: '50%', transform: 'translateX(-50%)' }}
      >
        <path d="M6 13 L1 2 A 5 5 0 0 1 11 2 Z" fill="#FFD93D" stroke="#fff" strokeWidth="1" />
      </svg>
    </span>
  );
}
